import React from 'react';

import { PaymentMethodFormKind, resolvePaymentMethodForm, type PaymentOption } from '@src/domains/payments';
import type { Transactable } from '@src/domains/transactables';
import { CardPaymentForm } from '@src/features/payments/card-form';
import { PixMethodBody } from '@src/features/payments/pix';

type PaymentMethodBodyProps = {
  option: PaymentOption;
  transactable: Transactable;
  onPaid?: () => void;
};

export const PaymentMethodBody = (props: PaymentMethodBodyProps) => {
  const { option, transactable, onPaid } = props;

  switch (resolvePaymentMethodForm(option.paymentMethod.code)) {
    case PaymentMethodFormKind.Card:
      return <CardPaymentForm paymentOption={option} transactable={transactable} onPaid={onPaid} />;
    case PaymentMethodFormKind.Pix:
      return <PixMethodBody paymentOption={option} transactable={transactable} onPaid={onPaid} />;
    default:
      return null;
  }
};

export default PaymentMethodBody;
